var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511 511.99976",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m287.855469 166.050781c-25.496094-29.097656-47.390625-55.292969-47.390625-90.984375 0-18.597656 6.894531-36.296875 19.195312-50.09375 4.199219-4.5 4.796875-11.398437 2.101563-16.800781-3.003907-5.699219-9-8.695313-15.300781-8.0976562-13.195313 1.8007812-41.09375 22.5000002-65.988282 53.6914062-2.101562 2.402344-4.199218 4.800781-6 7.5-30.59375 40.195313-63.289062 107.484375-58.191406 200.171875-19.195312-23.097656-30.894531-60.894531-26.394531-94.488281.898437-7.5-3.902344-14.699219-11.398438-16.496094-7.5-1.800781-15 2.398437-17.699219 9.597656-8.996093 24.898438-18.894531 44.691407-28.195312 63.589844-17.398438 34.195313-32.09375 63.890625-32.09375 107.386719 0 99.285156 80.6875 180.972656 179.972656 180.972656s179.972656-81.6875 179.972656-180.972656c0-81.589844-38.691406-125.984375-72.589843-164.976563zm0 0",
    fill: "#ffffff",
    "data-original": "#ff9100",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m360.445312 331.027344c0 99.285156-80.6875 180.972656-179.972656 180.972656v-458.234375c24.898438-31.191406 52.792969-51.890625 65.992188-53.6914062 6.296875-.5976568 12.296875 2.3984372 15.296875 8.0976562 2.699219 5.402344 2.097656 12.300781-2.101563 16.800781-12.296875 13.796875-19.195312 31.496094-19.195312 50.09375 0 35.691406 21.894531 61.886719 47.394531 90.984375 33.894531 38.992188 72.585937 83.386719 72.585937 164.976563zm0 0",
    fill: "#ffffff",
    "data-original": "#ff641a",
    style: {},
    className: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.83ff14b5.svg";
export { ForwardRef as ReactComponent };